import { useState } from 'react';
import { axiosInstance } from '../../../axios';
import './SummaryTable.css';


function MainTable({ mainTopicSocket, id, setMainTopicSocket }) {
    const [tempData, setTempData] = useState(null);
    const [editableField, setEditableField] = useState({ id: null, field: null });



    const handleSave = async (itemId) => {
        console.log("text")
        try {
            const formDataUpdate = new FormData();
            formDataUpdate.append('text', tempData.text);
            const response = await axiosInstance.patch(`summarize_main_topic/${id}/${itemId}/`, formDataUpdate);

            // Update detailTopicSocket with new data
            const updatedItems = mainTopicSocket.items.map(item => {
                if (item.id === itemId) {
                    return { ...item, title: tempData.title, text: tempData.text, loading: false };
                }
                return item;
            });
            setMainTopicSocket({ ...mainTopicSocket, items: updatedItems });

            setEditableField({ id: null, field: null });
            setTempData(null);

        } catch (error) {
            // TODO: handle errors
        }
    };

    const handleCancel = (itemId) => {
        setEditableField({ id: null, field: null });
        setTempData(null);
    };

    const toggleEditMode = (itemId, field) => {
        if (editableField.id === itemId && editableField.field === field) {
            setEditableField({ id: null, field: null });
            setTempData(null);  // Clear temporary data when closing edit mode
        } else {
            setEditableField({ id: itemId, field: field });
            const currentItem = mainTopicSocket.items.find(item => item.id === itemId);
            if (currentItem) {
                setTempData({ ...currentItem });
            }
        }
    };

        const handleFieldChange = (e, itemId, field) => {
        if (tempData && tempData.id === itemId) {
            setTempData({ ...tempData, [field]: e.target.value });
        }
    };



    return (<>
        <div className='card-body'>
            <div class="table-responsive " >

                <table class="table table-bordered shadow-sm">
                    <thead>
                    </thead>
                    <tr ><td className='bold border' style={{ paddingLeft: 20 }} colspan="2">{mainTopicSocket != null && mainTopicSocket.title} </td></tr>

                    {mainTopicSocket.items.map((item) => (
                        <tr key={item.id}>
                            <td className='text-center' style={{ width: '25%', verticalAlign: 'middle', position: 'relative', height: '250px' }}>
                                {/* {editableField.id === item.id && editableField.field === 'title' ? (
                                        <>
                                            <input
                                                type="text"
                                                value={tempData && tempData.id === item.id ? tempData.title : item.title}
                                                className="form-control border text-center  shadow"
                                                onChange={(e) => handleFieldChange(e, item.id, 'title')}
                                            />
                                            <a className="text-success text-decoration-none edit-icon-save" style={{ padding: 0 }}>
                                                <i className="fas fa-fw fa-save" style={{ fontSize: '1.2em' }}></i>
                                            </a>
                                            <a className="text-danger text-decoration-none edit-icon-close" style={{ padding: 0 }}>
                                                <i className="fas fa-fw fa-close" style={{ fontSize: '1.2em' }}></i>
                                            </a>
                                        </>
                                    ) : ( */}
                                <>
                                    <input
                                        type="text"
                                        className="form-control-plaintext readonly text-center"
                                        value={item.title}
                                        readOnly={true}
                                    />
                                    {/* <a className="text-black edit-icon" style={{ padding: 0 }}>
                                                <i className="fa fa-fw fa-edit " onClick={() => toggleEditMode(item.id, 'title')} style={{ display: 'block', fontSize: '1.2em' }}></i>
                                            </a> */}
                                </>
                                {/* )} */}

                            </td>
                            <td style={{ position: 'relative', padding: 25, height: '250px', }} className='border'>
                                {/* {editableField.id === item.id && editableField.field === 'text' ? (
                                        <>
                                            <textarea
                                                class="form-control border shadow"
                                                style={{ width: '100%', height: '90%' }}
                                                value={tempData && tempData.id === item.id ? tempData.text : item.text}
                                                onChange={(e) => handleFieldChange(e, item.id, 'text')}
                                            />
                                            <a onClick={() => handleSave(item.id)} style={{ padding: 0 }} className="text-success text-decoration-none edit-icon-save">
                                                <i className="fas fa-fw fa-save" style={{ fontSize: '1.2em' }}></i>
                                            </a>
                                            <a onClick={() => handleCancel(item.id)} style={{ padding: 0 }} className="text-danger text-decoration-none edit-icon-close">
                                                <i className="fas fa-fw fa-close" style={{ fontSize: '1.2em' }}></i>
                                            </a>
                                        </>
                                    ) : ( */}
                                <>
                                    {/* <textarea
                                                value={item.text}
                                                class="form-control-plaintext readonly bg-white"
                                                disabled={true}
                                                style={{ width: '100%', height: '90%' }}

                                            /> */}
                                    {editableField.id === item.id && editableField.field === 'text' ? (
                                            <>
                                                <textarea
                                                    class="form-control border shadow"
                                                    style={{ width: '100%', height: '90%' }}
                                                    value={tempData && tempData.id === item.id ? tempData.text : item.text}
                                                    onChange={(e) => handleFieldChange(e, item.id, 'text')}
                                                />
                                                <a onClick={() => handleSave(item.id)} className="text-success text-decoration-none edit-icon-save" style={{ padding: 0 }}>
                                                    <i className="fas fa-fw fa-save" style={{ fontSize: '1.2em' }}></i>
                                                </a>
                                                <a onClick={() => handleCancel(item.id)} className="text-danger text-decoration-none edit-icon-close" style={{ padding: 0 }}>
                                                    <i className="fas fa-fw fa-close" style={{ fontSize: '1.2em' }}></i>
                                                </a>
                                            </>
                                        ) : (
                                            <>
                                               <p style={{ whiteSpace: 'pre-line' }}>{item.text}</p>
                                                        <a className="text-black edit-icon-text " style={{ padding: 0 }}>
                                                            <i className="fa fa-fw fa-edit" style={{ display: 'block', fontSize: '1.2em' }} onClick={() => toggleEditMode(item.id, 'text')}></i>
                                                        </a>

                                            </>
                                        )}
                                    {/* <a className="text-black edit-icon" style={{ padding: 0 }}>
                                                <i className="fa fa-fw fa-edit " onClick={() => toggleEditMode(item.id, 'text')} style={{ display: 'block', fontSize: '1.2em' }}></i>
                                            </a> */}
                                </>
                                {/* )} */}
                            </td>
                        </tr>
                    ))}

                    {mainTopicSocket.items.length < 2 && (<>
                        <tr >
                            <td className='text-center border' style={{ width: '25%', paddingLeft: 20, paddingRight: 20, verticalAlign: 'middle', position: 'relative', height: '120px' }}>
                                <p className='skeleton-loading'>test</p>
                            </td>
                            <td className='text-center border' style={{ paddingLeft: 20, paddingRight: 20 }}>
                                <p className='skeleton-loading'>test</p>
                            </td>
                        </tr>
                    </>)}


                </table>
            </div>
        </div>
    </>);
}

export default MainTable;